import { defineFcm } from '../shared/factory';

export const FCM_PSF_CONTEXTUAL_BANDITS_ENABLED = defineFcm('psf_contextual_bandits_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		context: 'Combo Page + Promote Page',
		description:
			'This FC is used to enable the standalone bandit_service psf_combo and contextual_promotion_button bandits on the Combo and Promote pages (respectively). Note: the contextual_promotion_buttons depends on the psf_combo bandit to be enabled.',
		import: false,
	});
